import { Check } from "lucide-react";

export interface Step {
  number: number;
  title: string;
  shortTitle?: string;
  subtitle?: string;
  icon: any;
  completed: boolean;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
  onStepClick: (stepNumber: number) => void;
  getStepProgress: () => number;
}

export const StepIndicator = ({
  steps,
  currentStep,
  onStepClick,
  getStepProgress,
}: StepIndicatorProps) => {
  return (
    <div className="relative mt-1.5  overflow-hidden sm:overflow-visible -mx-2 px-2">
      {/* Progress line is hidden on small screens to avoid layout issues */}
      <div className="absolute top-6 left-0 right-0 h-px bg-gray-200 hidden sm:block" />
      <div
        className="absolute top-6 left-0 h-px bg-gray-900 transition-all duration-500 ease-out hidden sm:block"
        style={{ width: `${getStepProgress()}%` }}
      />
      <div className="flex justify-between gap-1.5 sm:gap-0 relative w-full">
        {steps.map((step) => {
          const Icon = step.icon as any;
          const isActive = currentStep === step.number;
          const isCompleted = step.completed;
          const isClickable = step.number <= currentStep;
          return (
            <div
              key={step.number}
              className={`flex flex-col items-center cursor-pointer transition-all duration-200 flex-1 sm:flex-initial min-w-0 ${isClickable ? "hover:scale-105" : "cursor-not-allowed"}`}
              onClick={() => onStepClick(step.number)}
            >
              <div
                className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-all duration-200 border-2 ${isCompleted ? "bg-gray-900 border-gray-900 text-white" : isActive ? "bg-white border-gray-900 text-gray-900 shadow-sm" : "bg-white border-gray-200 text-gray-400"}`}
              >
                {isCompleted ? (
                  <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                ) : (
                  <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                )}
              </div>
              <div className="mt-1 sm:mt-2 text-center leading-none">
                <div
                  className={`text-[11px] sm:text-xs font-medium transition-colors duration-200 ${isActive || isCompleted ? "text-gray-900" : "text-gray-500"}`}
                >
                  <span className="sm:hidden">
                    {step.shortTitle ?? step.title}
                  </span>
                  <span className="hidden sm:inline">{step.title}</span>
                </div>
                <div className="text-xs text-gray-400 mt-1 hidden sm:block">
                  {step.subtitle}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
